export const name = 'gzResponsiveDialog';

/**
 * @ngdoc directive
 * @name gazelle.components.responsive.directive:gzResponsiveDialog
 *
 * @description
 * `gz-responsive-dialog` is an attribute directive for a preset of flex classes
 * providing a width pattern.
 *
 * @usage
 * ```html
 * <md-dialog gz-responsive-dialog></md-dialog>
 * ```
 */
export default function gzResponsiveDialog() {
  'ngInject';

  let directive = {
    restrict: 'A',
    link: gzResponsiveLink,
  };
  return directive;

  //////////////////////

  function gzResponsiveLink(scope, element) {
    // Tried to add material flex directives but struggled
    // (see http://stackoverflow.com/questions/19224028/add-directives-from-directive-in-angularjs).
    // Using material flex classes instead since the attributes are just class wrappers.
    element.addClass('flex-xs-100');
    element.addClass('flex-sm-65');
    element.addClass('flex-md-50');
    element.addClass('flex-35');
  }
}
